/* RubyGator product page: stock status under the price, kept in sync with the selected variant. */
(function () {
  var TEXT = {
    nl: { in: 'Op voorraad', ship: 'binnen 24 uur verzonden', low: 'Nog maar {n} op voorraad', out: 'Uitverkocht', backorder: 'Beschikbaar als pre-order', outNote: 'Wanneer dit product terugkomt, weten we zelf nog niet. We nemen geen reserveringen aan.' },
    en: { in: 'In stock', ship: 'shipped within 24 hours', low: 'Only {n} left in stock', out: 'Sold out', backorder: 'Available to pre-order', outNote: 'We don’t know yet when this product will be back, and we don’t take reservations.' }
  };

  function render(box, data, id) {
    var status = box.querySelector('[data-rg-stock-status]');
    var v = data.variants[id];
    if (!status || !v) return;
    var t = data.en ? TEXT.en : TEXT.nl;
    var state = v.s;
    var label;
    if (state === 'in' && v.q > 0 && v.q <= data.low) {
      state = 'low';
      label = t.low.replace('{n}', v.q);
    } else {
      label = t[state];
    }
    status.className = 'rg-pdp-stock__status rg-pdp-stock__status--' + state;
    status.textContent = '';
    var dot = document.createElement('span');
    dot.className = 'rg-pdp-stock__dot';
    dot.setAttribute('aria-hidden', 'true');
    var strong = document.createElement('strong');
    strong.textContent = label;
    status.appendChild(dot);
    status.appendChild(strong);
    if (state === 'in' || state === 'low') status.appendChild(document.createTextNode(' · ' + t.ship));
    var note = box.querySelector('.rg-pdp-stock__note');
    if (state === 'out') {
      if (!note) {
        note = document.createElement('p');
        note.className = 'rg-pdp-stock__note';
        status.insertAdjacentElement('afterend', note);
      }
      note.textContent = t.outNote;
    } else if (note) {
      note.remove();
    }
  }

  function init(box) {
    var json = box.querySelector('[data-rg-stock-json]');
    if (!json) return;
    var data;
    try {
      data = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    render(box, data, data.current);
    var scope = box.closest('.bls__product-details-infor') || document;
    var input = scope.querySelector('#product-form input[name="id"]') || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (!input) return;
    // The theme changes the hidden variant id when another option is chosen
    var last = input.value;
    var sync = function () {
      if (input.value !== last) {
        last = input.value;
        render(box, data, input.value);
      }
    };
    document.addEventListener('change', function () { setTimeout(sync, 60); });
    document.addEventListener('click', function () { setTimeout(sync, 60); });
  }

  function start() {
    document.querySelectorAll('[data-rg-stock]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
